import { Eye, EyeOff } from "lucide-react";
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import { brl } from "./hooks";

type MoneyVisibilityValue = {
  visible: boolean;
  toggle: () => void;
  money: (value: string) => string;
};

const MoneyVisibilityContext = createContext<MoneyVisibilityValue | null>(null);

export function MoneyVisibilityProvider({ children }: { children: ReactNode }) {
  const [visible, setVisible] = useState(false);
  const toggle = useCallback(() => setVisible((current) => !current), []);
  const money = useCallback((value: string) => visible ? brl(value) : "R$ ••••", [visible]);
  const context = useMemo(() => ({ visible, toggle, money }), [money, toggle, visible]);
  return <MoneyVisibilityContext.Provider value={context}>{children}</MoneyVisibilityContext.Provider>;
}

export function useMoneyVisibility() {
  const context = useContext(MoneyVisibilityContext);
  if (!context) throw new Error("useMoneyVisibility deve ser usado dentro de MoneyVisibilityProvider");
  return context;
}

export function MoneyVisibilityButton() {
  const { visible, toggle } = useMoneyVisibility();
  const label = visible ? "Ocultar valores" : "Mostrar valores";
  return <button className="money-visibility" type="button" onClick={toggle} aria-label={label} title={label} aria-pressed={visible}>
    {visible ? <EyeOff size={21} /> : <Eye size={21} />}
  </button>;
}
